import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cva } from 'class-variance-authority';
import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';
const buttonVariants = cva([
    'relative inline-flex select-none items-center justify-center gap-2 whitespace-nowrap',
    'font-display font-semibold tracking-wide uppercase',
    'transition-[transform,box-shadow,background-color,filter] duration-150 ease-out',
    'rounded-2xl border border-transparent',
    'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-electric-400',
    'disabled:cursor-not-allowed disabled:opacity-50 disabled:saturate-50',
    'active:translate-y-[1px] active:scale-[0.98]',
], {
    variants: {
        variant: {
            primary: 'bg-gradient-electric text-white shadow-glow-electric hover:brightness-110 hover:-translate-y-[1px]',
            flame: 'bg-gradient-flame text-white shadow-glow-flame hover:brightness-110 hover:-translate-y-[1px]',
            royal: 'bg-gradient-royal text-white shadow-glow-royal hover:brightness-110 hover:-translate-y-[1px]',
            secondary: 'bg-ink-800 text-ink-50 border-ink-700 hover:bg-ink-700 hover:border-ink-600',
            ghost: 'bg-transparent text-ink-200 hover:bg-ink-800/60 hover:text-ink-50',
            outline: 'bg-transparent text-electric-300 border-electric-500/40 hover:bg-electric-500/10 hover:border-electric-400',
            destructive: 'bg-rose-600 text-white shadow-[0_8px_32px_-12px_rgba(244,63,94,.7)] hover:brightness-110',
        },
        size: {
            sm: 'h-9  px-3 text-xs',
            md: 'h-11 px-5 text-sm',
            lg: 'h-14 px-7 text-base',
            xl: 'h-16 px-9 text-lg',
            icon: 'h-11 w-11 p-0 text-sm',
        },
        fullWidth: { true: 'w-full', false: '' },
    },
    defaultVariants: {
        variant: 'primary',
        size: 'md',
        fullWidth: false,
    },
});
export const Button = forwardRef(function Button({ className, variant, size, fullWidth, isLoading, leftIcon, rightIcon, children, disabled, ...props }, ref) {
    return (_jsxs("button", { ref: ref, "data-focus-managed": true, className: cn(buttonVariants({ variant, size, fullWidth }), className), disabled: disabled || isLoading, ...props, children: [isLoading ? (_jsx(Loader2, { className: "h-4 w-4 animate-spin", "aria-hidden": true })) : (leftIcon && _jsx("span", { className: "-ml-0.5 flex items-center", children: leftIcon })), children && _jsx("span", { children: children }), !isLoading && rightIcon && _jsx("span", { className: "-mr-0.5 flex items-center", children: rightIcon })] }));
});
